import React from "react";
import { DOCUMENT_ENTITY_TYPES } from "services/documentFolderService";
import DocumentManager from "components/shared/DocumentManager";

const DocumentsTab = ({
  isMobile,
  leadId,
  refreshProgressJourney,
  IsFinalApproved = false,
  afterFinalApprove = () => {},
  isStudent = false,
  useDocumentsData: useDocumentsDataProp,
}) => {
  return (
    <div className="flex-1 min-h-0 flex flex-col h-full overflow-hidden">
      <DocumentManager
        entityType={DOCUMENT_ENTITY_TYPES.LEAD}
        entityId={leadId}
        title="Documents"
        isMobile={isMobile}
        isStudent={isStudent}
        IsFinalApproved={IsFinalApproved}
        afterFinalApprove={afterFinalApprove}
        refreshProgressJourney={refreshProgressJourney}
        useDocumentsData={useDocumentsDataProp}
        features={{
          enableVerification: true,
          enableAssignInspectors: true,
          enableHistoryView: true,
          enableSetDefaultFolder: false,
        }}
      />
    </div>
  );
};

export default DocumentsTab;
